module.exports = __webpack_public_path__ + "img/nextron.f514ab4f.png";